<template>
  <div class="account-setting-button" v-on:click="action">
    <span class="account-setting-title" :class="color">{{ title }}</span>
    <span class="button-icon fa fa-chevron-left" :class="color"></span>
  </div>
</template>

<script>
import router from '@/router';
import Segment from '../../../../../../Segment';

export default {
  name: 'AccountSettingButton',
  props: {
    title: {
      type: String,
      required: true,
    },
    action: {
      type: Function,
      required: true,
    },
    color: {
      type: String,
      default: 'black',
    },
  },
  methods: {
    addMember() {
      Segment.trackUserInteraction('InviteMemberClicked');
      router.push({ path: '/invite-member', query: this.$route.query });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~base-ui/src/scss/riseup-colors";

  .account-setting-button {
    height: 64px;
    width: 100%;
    padding: 0 23px;
    border-radius: 5px;
    box-shadow: 0 0 6px 0 $riseup_gray_1;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    margin-top: 16px;

    .account-setting-title {
      font-size: 16px;
      font-weight: bold;

      &.red {
        color: $riseup_coral;
      }
    }

    .button-icon {
      &.red {
        color: $riseup_coral;
      }
    }
  }
</style>
